import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SwUpdate, UpdateAvailableEvent } from '@angular/service-worker';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { LoginComponent } from 'src/app/modals/login/login.component';
import { FirebaseAuthService } from 'src/app/_services/firebase-auth.service';
import { Router, NavigationEnd } from '@angular/router';
import { Product } from 'src/app/models/product';
import { ProductService } from 'src/app/_services/product.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { UserService } from 'src/app/_services/user.service';
import { DOCUMENT } from '@angular/common';
import { SidenavService } from 'src/app/_services/sidenav.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {

  hidenMenu = false;

  @Input() diviceXs: boolean;
  @Input() diviceSm: boolean;

  updateAvailable = false;

  searchProdCrl = new FormControl();
  subscriptions: Subscription[] = [];

  products: Product[];

  showBtnsPerfil: boolean;

  constructor(private updates: SwUpdate, public matDialog: MatDialog, public firebaseAuthService: FirebaseAuthService,
    public router: Router, private productService: ProductService, private afAuth: AngularFireAuth,
    public userService: UserService, private sidenav: SidenavService) {

                afAuth.authState.subscribe( user => {
                  if (user) {
                    firebaseAuthService.publicUser = user;
                    firebaseAuthService.loguedIn = true;
                    console.log('usuario logueado: ', firebaseAuthService.publicUser );
                    this.firebaseAuthService.displayNameObs = this.firebaseAuthService.getPublicUserByEmail(user.email).pipe(map(user => user ? user.displayName : null));

                    firebaseAuthService.getLoguedPrivateProfileUser(user.uid).subscribe(privateProfile => {
                      console.log('logueado *:', privateProfile);
                      if (privateProfile) {
                        firebaseAuthService.privateProfile = privateProfile;
                        firebaseAuthService.completeRegister = false;
                        this.userService.checkShopingCartInLocalStorage();

                      } else {
                        firebaseAuthService.completeRegister = true;
                      }
                    })
                  } else {
                    console.log('No hay usuario logueado');
                  }
                });


              }

  ngOnInit(): void {
    this.initUpdater();
    this.loadAllProducts();

    // this.checkForProductsInShoppinCartLocalstorage();


  }

  loadAllProducts(): void {
    this.productService.loadAllProducts().subscribe(products => {
      this.products = products;
      console.log( 'todos: ', this.products);
    });
  }


  // checkForProductsInShoppinCartLocalstorage(): void{
  //   const shoppingCartInLocalStorage: Product[] = JSON.parse(localStorage.getItem('tugessiShoppingCart'));
  //   console.log('carrito en localStorage: ', shoppingCartInLocalStorage);

  // }

  //Para obtener los datos en la ventana de cada producto
  // pruebaObPorId(){
  //   this.productService.getProductById('IeT9EJWCLLowyYiwvsFe')
  //       .subscribe(product => {console.log('pruebaProd:', product);
  //           product.suggestedProducts.forEach(element => {
  //             console.log('relacionados: ', element.id);
  //             element.get().then(prod => {
  //               console.log(prod.data());
  //             })
  //           });
  //   });
  // }

  updateApp(): void {
    this.updateAvailable = false;
    this.updates.activateUpdate();
    window.location.reload();
  }

  initUpdater(): void {
    this.subscriptions.push(this.updates.available.subscribe(e => this.onUpdateAvailable(e)));
    this.subscriptions.push(this.updates.activated.subscribe(() => this.onUpdateActivated()));
  }

  onUpdateActivated(): void {
    console.log('mostrar aviso de actualización en curso');
  }

  onUpdateAvailable(event: UpdateAvailableEvent): void {
    const updateMessage = event.available.appData['updateMessage'];

    console.log('Mostrar aviso de actualización disponible...');

    console.log('Disparar lógica de actualización si el usuario acepta...');

    console.log('Suponagmoas que aceptó entonces actualizamos...');
    alert('Actaulizando...');

    if (confirm('Actualizando...')) {
      this.updateApp();
    } else {
      alert('no quiso actualizar');
    }
  }

  goToLogIn(): void{
    const dialogRef = this.matDialog.open(LoginComponent, {
      hasBackdrop: true,
      height: '90%'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  goToProfile(): void {
    // this.router.navigate(['/profile']);
    this.router.navigate([{outlets: {primary: 'profile' ,sidebar: 'profile'}}]);
  }

  ngDoCheck() {
    let currentUrl;
    let splitedUrl;
    let otherUrl;
    let otherUrlSplit;

    this.router.events.subscribe(event => {

      if (event instanceof NavigationEnd ) {

        currentUrl = event.url;

        let currentUrlSplit = currentUrl.split("(")

        splitedUrl = currentUrlSplit[0]

        otherUrl = splitedUrl.split("/");

        if(otherUrl.length > 0 ){

          otherUrlSplit = otherUrl[1]

        }

      }


      if(splitedUrl === '/profile' || splitedUrl === '/referred' || splitedUrl === '/compras' || otherUrlSplit === "purchasesDetail"){
        this.hidenMenu = true;
        this.showBtnsPerfil = true;
      }
      else{
        this.hidenMenu = false;
        this.showBtnsPerfil = false;
      }

    });
  }

  closeSlidenNav(){
    this.sidenav.close();
  }

}
